import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import {
  BaseAutocomplete,
  BaseAutocompleteProps,
} from '../autocomplete/BaseAutocomplete/BaseAutocomplete';
import { InputAddons } from '../input-addons/InputAddons';
import { IAddonsProps, IInputSearchProps } from '../common/props';

export type SelectBoxProps<API_TYPE, VAL_TYPE> = IAddonsProps &
  IInputSearchProps &
  Omit<
    BaseAutocompleteProps<API_TYPE, VAL_TYPE>,
    'touched' | 'error' | 'inline' | 'getDropDownIcon' | 'actions'
  >;

export class SelectBox<
  API_TYPE,
  VAL_TYPE = API_TYPE
> extends React.PureComponent<SelectBoxProps<API_TYPE, VAL_TYPE>> {
  render() {
    const {
      className,
      tree,
      inputProps,
      addonAfter,
      addonAfterCompact,
      onSearch,
      disabled,
      readOnly,
      showMenuOnFocus = false,
      colors = false,
      dataTest,
      ...other
    } = this.props;
    let cls = classNames(
      className,
      Classes.BASE_AUTOCOMPLETE,
      Classes.SELECTBOX,
      {
        [Classes.BASE_AUTOCOMPLETE_TREE]: tree,
        [Classes.FIELD_INPUT_DISABLED]: disabled,
        [Classes.FIELD_INPUT_READONLY]: readOnly,
      }
    );

    return (
      <InputAddons
        addonAfter={addonAfter}
        addonAfterCompact={addonAfterCompact}
      >
        <BaseAutocomplete
          dataTest={dataTest}
          showMenuOnFocus={showMenuOnFocus}
          className={cls}
          inputProps={{ className: Classes.FIELD_INPUT, ...inputProps }}
          tree={tree}
          onSearch={onSearch}
          {...other}
          disabled={disabled}
          readOnly={readOnly}
          colors={colors}
        />
      </InputAddons>
    );
  }
}
